import { createApi } from '@reduxjs/toolkit/query/react';
import { Project } from '../../models/project';
import { ApiResponse } from '../../services/httpService';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';

const projectsApiUrl = 'api/Projects';

export const projectsService = createApi({
  reducerPath: 'projectsService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Projects'],

  endpoints: (builder) => ({
    getProjectsByProjectCode: builder.query<Project[], string | undefined>({
      query: (projectCode) => `${projectsApiUrl}/${projectCode}/Projects`,
      providesTags: ['Projects'],
      transformResponse: (response: ApiResponse<Project>) => {
        return response.items;
      },
    }),
  }),
});

export const { useGetProjectsByProjectCodeQuery } = projectsService;
